import React from 'react';
// Ganti isi <svg> di bawah ini dengan SVG icon custom Anda.
// Pastikan ukuran viewBox="0 0 24 24" agar konsisten dengan icon lain.
export function UserPlusIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      {/* Contoh isi SVG, silakan ganti dengan SVG Anda */}
      <circle cx="12" cy="9" r="4" fill="#F74F8E"/>
      <rect x="6" y="17" width="12" height="4" rx="2" fill="#F7A7C7"/>
      <rect x="18" y="11" width="2" height="6" rx="1" fill="#F74F8E"/>
      <rect x="17" y="14" width="6" height="2" rx="1" fill="#F74F8E"/>
    </svg>
  );
} 